import React, { useState, memo } from 'react';
import type { FilterNumberRangeProps } from '../FilterPanel.types';

function FilterNumberRangeComponent({ config, value, onChange, compact }: FilterNumberRangeProps): React.ReactElement {
  const [localMin, setLocalMin] = useState<string>(value?.min?.toString() || '');
  const [localMax, setLocalMax] = useState<string>(value?.max?.toString() || '');

  const handleMinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const strValue = e.target.value;
    setLocalMin(strValue);

    const numValue = strValue === '' ? null : parseFloat(strValue);
    if (strValue === '' || !isNaN(numValue as number)) {
      onChange({
        min: numValue,
        max: value?.max ?? null
      });
    }
  };

  const handleMaxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const strValue = e.target.value;
    setLocalMax(strValue);

    const numValue = strValue === '' ? null : parseFloat(strValue);
    if (strValue === '' || !isNaN(numValue as number)) {
      onChange({
        min: value?.min ?? null,
        max: numValue
      });
    }
  };

  const inputStyle: React.CSSProperties = {
    width: '100%',
    padding: compact ? 'var(--space-2) var(--space-3)' : 'var(--space-2) var(--space-3)',
    fontSize: 'var(--text-sm)',
    fontFamily: 'var(--font-mono)',
    borderRadius: 'var(--radius-md)',
    border: '1px solid var(--color-border-default)',
    background: 'var(--color-bg-elevated)',
    color: 'var(--color-text-primary)',
    outline: 'none',
    transition: 'border-color var(--transition-fast)'
  };

  return (
    <div>
      <label style={{
        display: 'block',
        fontSize: 'var(--text-xs)',
        fontWeight: 500,
        color: 'var(--color-text-secondary)',
        marginBottom: 'var(--space-1)'
      }}>
        {config.label}
      </label>
      <div style={{
        display: 'flex',
        gap: 'var(--space-2)',
        alignItems: 'center'
      }}>
        <input
          type="number"
          value={localMin}
          onChange={handleMinChange}
          placeholder={config.min?.toString() || 'Min'}
          min={config.min}
          max={config.max}
          step={config.step || 1}
          style={inputStyle}
          onFocus={(e) => {
            e.currentTarget.style.borderColor = 'var(--color-primary)';
          }}
          onBlur={(e) => {
            e.currentTarget.style.borderColor = 'var(--color-border-default)';
          }}
        />
        <span style={{
          color: 'var(--color-text-tertiary)',
          fontSize: 'var(--text-sm)'
        }}>
          —
        </span>
        <input
          type="number"
          value={localMax}
          onChange={handleMaxChange}
          placeholder={config.max?.toString() || 'Max'}
          min={config.min}
          max={config.max}
          step={config.step || 1}
          style={inputStyle}
          onFocus={(e) => {
            e.currentTarget.style.borderColor = 'var(--color-primary)';
          }}
          onBlur={(e) => {
            e.currentTarget.style.borderColor = 'var(--color-border-default)';
          }}
        />
      </div>
    </div>
  );
}

export const FilterNumberRange = memo(FilterNumberRangeComponent);
